module.exports = __webpack_public_path__ + "static/Laser dentistry smile after-236c80d8d5b60fc853be8f81cf4ff1b7.jpg";